import store from "@/store/store";
import { EventBus } from "@modules/websocket";

EventBus.$on("sync", () => store.dispatch("synchronization/sync"));
EventBus.$on("logout", (event) => store.dispatch("user/logOut", event.message));
EventBus.$on("config", (data) => store.dispatch("clientConfig/setConfig", data));
EventBus.$on("alert", (data) => {
  const language = store.getters["user/account"]?.language ?? "tr";
  if (data.alertType == "SUCCESS") {
    EventBus.$toast.success(data.message[language], { timeout: 20000 });
  } else if (data.alertType == "ERROR") {
    EventBus.$toast.error(data.message[language], { timeout: 20000 });
  } else if (data.alertType == "WARNING") {
    EventBus.$toast.warning(data.message[language], { timeout: 20000 });
  } else if (data.alertType == "INFO") {
    EventBus.$toast.info(data.message[language], { timeout: 20000 });
  }
});
EventBus.$on("notification", (data) => {
  if (data.scope == "ACCOUNT") {
    store.dispatch("accountNotification/unshift", data);
  }
});
// TKP-242 q.2: arka plandaki toplu taslak işlemi bitti — taslaklar bir kez yenilenir (bildirimi sunucu gönderir; açık paneller olayı dinler)
EventBus.$on("approval-batch-completed", () => store.dispatch("approval/batchCompleted").catch(() => undefined));
